import type { FunctionComponent } from 'react';
import type * as T from './ConsultantItem.types';
import * as s from './ConsultantItem.css';
import classNames from 'classnames';
import Title from '@media-ui/core/src/components/Title';
import Link from '@media-ui/core/src/components/Link';
import Text from '@media-ui/core/src/components/Text';
import Avatar from '@media-ui/core/src/components/Avatar';
import { counterTrigger } from 'Src/tools/counters';
const ConsultantItem: FunctionComponent<T.IConsultantItemProps> = (props) => {
    const { className, consultant, avatarType = 'page', isBorderedImage, clickCounterName, } = props;
    const { avatar, name, href, position } = consultant;
    const renderPicture = () => {
        const selectedAvatar = avatar?.[avatarType];
        return (<div className={s.picture}>
        <Avatar showEmpty={!selectedAvatar} className={s.avatar} picture={selectedAvatar} size="xl"/>
      </div>);
    };
    const handleClick = () => {
        if (clickCounterName) {
            counterTrigger(clickCounterName);
        }
    };
    return (<div className={classNames(s.root, className, {
            [s.borderedImage]: isBorderedImage,
        })}>
      {renderPicture()}
      <Title level="3" className={s.title}>
        <Link href={href} holder onClick={handleClick}>
          {name}
        </Link>
      </Title>
      {position && (<Text color="secondary" className={s.position}>
          {position}
        </Text>)}
    </div>);
};
export default ConsultantItem;
